import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { copyFor } from '../../copy/copy';

const LinkedInIcon = props => (
    <svg
        width={props.isMobileResolution ? 52 : 36}
        height={props.isMobileResolution ? 52 : 36}
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>{copyFor('icons', 'linkedin')}</title>
        <path
            d="M11.426 14.824h2.699v9.406h-2.699v-9.406zm1.28-1.176h-.019c-.977 0-1.61-.719-1.61-1.63 0-.929.652-1.633 1.648-1.633.996 0 1.608.703 1.628 1.63 0 .911-.632 1.633-1.646 1.633zm12.217 10.583h-3.06v-4.868c0-1.274-.479-2.143-1.531-2.143-.806 0-1.253.586-1.462 1.152-.078.203-.066.485-.066.77v5.089h-3.031s.039-8.623 0-9.407h3.031v1.477c.18-.646 1.148-1.567 2.694-1.567 1.918 0 3.425 1.354 3.425 4.266v5.23z"
            fillRule="evenodd"
            fill="#000"
        />
    </svg>
);

LinkedInIcon.propTypes = {
    isMobileResolution: PropTypes.bool.isRequired
};

export default connect(
    state => ({
        isMobileResolution: state.widget.isMobileResolution
    }),
    {}
)(LinkedInIcon);
